/* IMPERIAL WATCH PDP — CONSOLIDATED FINAL JS — 03 OCT 2026 */

;

/* PDP */
(()=>{const C={black:'#111111',white:'#f7f7f5',navy:'#15263f','navy blue':'#15263f',blue:'#3d6ea8','light blue':'#9dc5e0',green:'#2f6b4f','light green':'#a8d7ae',red:'#9c2f2f',pink:'#e4a9b8','sand pink':'#d8ada5',yellow:'#e5c95c',orange:'#d9793b',grey:'#7d858c',gray:'#7d858c',silver:'#b9bcc1',gold:'#b9975b','rose gold':'#c99378',brown:'#6b4938',beige:'#d8cbb0',cream:'#ede4cf',turquoise:'#41a8a9',purple:'#66527c',burgundy:'#6e2334','blue & orange':'linear-gradient(135deg,#3d6ea8 0 50%,#d9793b 50% 100%)','blue and orange':'linear-gradient(135deg,#3d6ea8 0 50%,#d9793b 50% 100%)'};const n=v=>String(v||'').trim().toLowerCase().replace(/[_-]+/g,' ').replace(/\s+/g,' ');const colourName=name=>{const k=n(name).replace('colour','color');return k==='color'||k.endsWith(' color')||k.includes('strap color')||k.includes('dial color')};const variants=root=>{try{return JSON.parse(root.querySelector('[data-imperial-watch-variants]')?.textContent||'[]')}catch(e){return[]}};const current=root=>{const id=String(root.querySelector('.product-variant-id')?.value||'');return variants(root).find(v=>String(v.id)===id)||null};function swatches(root){root.querySelectorAll('.imperial-watch-variants fieldset,.imperial-watch-variants .product-form__input').forEach(g=>{const rs=[...g.querySelectorAll('input[type=radio]')];if(!rs.length)return;const name=rs[0].name||g.querySelector('legend,.form__label')?.textContent||'';if(!colourName(name))return;rs.forEach(r=>{const l=root.querySelector(`label[for="${CSS.escape(r.id)}"]`);if(!l)return;const native=l.querySelector('.swatch')||r.dataset.optionSwatchValue;if(native)return;const c=C[n(r.value)];l.classList.remove('color-swatch','color-swatchimg','imperial-watch-qa-swatch','imperial-watch-qa-text-option');if(c){l.classList.add('imperial-watch-qa-swatch');l.style.setProperty('--imperial-qa-swatch',c);l.style.setProperty('background',c,'important');l.title=r.value;l.setAttribute('aria-label',r.value)}else{l.classList.add('imperial-watch-qa-text-option');l.style.setProperty('background','transparent','important');l.style.setProperty('background-image','none','important');l.title=r.value}})})}function sync(root){const v=current(root);if(!v)return;const a=root.querySelector('[data-imperial-watch-availability]'),t=root.querySelector('[data-imperial-watch-availability-text]');if(a&&t){t.textContent=v.availabilityMessage||(v.available?'Available now':'Sold / unavailable');a.classList.toggle('is-unavailable',!v.available)}const q=root.querySelector('[data-imperial-watch-quantity]');if(q){const show=v.inventoryManagement==='shopify'&&Number(v.inventoryQuantity)>1;q.classList.toggle('is-hidden',!show);const i=q.querySelector('input[name=quantity]');if(i&&show){i.max=String(v.inventoryQuantity);if(Number(i.value)>Number(v.inventoryQuantity))i.value='1'}}const s=root.querySelector('[data-imperial-watch-sticky]');if(s){s.dataset.available=String(Boolean(v.available));if(!v.available){s.classList.remove('is-visible');s.hidden=true}}const sp=root.querySelector('[data-imperial-watch-sticky-price]');if(sp&&v.priceFormatted)sp.textContent=v.priceFormatted;let m=`Hello Imperial Time, I am interested in ${root.dataset.productTitle||''}`;if(root.dataset.productReference)m+=`, reference ${root.dataset.productReference}`;m+=`. ${v.url||location.href}`;root.querySelectorAll('a[data-imperial-whatsapp-context],.imperial-whatsapp-button').forEach(x=>x.href=`https://wa.me/447538174795?text=${encodeURIComponent(m)}`);const d=root.querySelector('.imperial-offer-dialog');if(d){const f=d.querySelector('form');if(f){const vals=[];root.querySelectorAll('.imperial-watch-variants input[type=radio]:checked').forEach(x=>vals.push(`${x.name}: ${x.value}`));const o=f.querySelector('[data-offer-selected-options]');if(o)o.value=vals.join(', ');const u=f.querySelector('[data-offer-product-url]');if(u)u.value=location.href;const p=f.querySelector('[data-offer-list-price]');if(p){const el=root.querySelector('[id^=price-]');if(el)p.value=el.innerText.replace(/\s+/g,' ').trim()}}}}function normaliseMediaAlt(root){if(root.dataset.titleConflict!=='true')return;const title=(root.dataset.productTitle||'').trim();if(!title)return;root.querySelectorAll('.product__media img,.thumbnail img').forEach((img,index)=>{const alt=img.getAttribute('alt')||'';if(/\b(?:19|20)\d{2}\b/.test(alt))img.setAttribute('alt',`${title} - product image ${index+1}`)})}function sticky(root){const s=root.querySelector('[data-imperial-watch-sticky]'),b=root.querySelector('.product-form__submit');if(!s||!b||s.dataset.bound)return;s.dataset.bound='1';const sb=s.querySelector('[data-imperial-watch-sticky-submit]'),mq=matchMedia('(max-width:749px)');let vis=true;const paint=()=>{const v=current(root),can=Boolean(v?.available)&&!b.disabled,show=mq.matches&&!vis&&can&&!document.body.classList.contains('imperial-watch-modal-open')&&!document.body.classList.contains('imperial-commerce-overlay-open')&&!document.body.classList.contains('overflow-hidden');s.hidden=!mq.matches||!can;requestAnimationFrame(()=>s.classList.toggle('is-visible',show))};new IntersectionObserver(e=>{vis=e[0]?.isIntersecting??true;paint()},{threshold:.05}).observe(b);sb?.addEventListener('click',()=>{if(!b.disabled)b.click()});mq.addEventListener?.('change',paint);new MutationObserver(paint).observe(b,{attributes:true,attributeFilter:['disabled','class']});paint()}function dialogs(root){const d=root.querySelector('.imperial-offer-dialog');if(!d||d.dataset.stateBound)return;d.dataset.stateBound='1';const u=()=>document.body.classList.toggle('imperial-watch-modal-open',Boolean(d.open));d.addEventListener('close',u);d.addEventListener('cancel',u);root.querySelector('[data-imperial-offer-open]')?.addEventListener('click',()=>requestAnimationFrame(u))}function parallax(root){const s=root.querySelector('[data-imperial-parallax]'),m=s?.querySelector('.imperial-watch-kensington__mark');if(!s||!m||s.dataset.parallaxBound)return;s.dataset.parallaxBound='1';const mq=matchMedia('(min-width:750px) and (prefers-reduced-motion:no-preference)');let active=false,tick=false;const paint=()=>{tick=false;if(!active||!mq.matches){s.style.removeProperty('--imperial-parallax-y');return}const r=s.getBoundingClientRect(),d=Math.max(-18,Math.min(18,(innerHeight/2-(r.top+r.height/2))*.035));s.style.setProperty('--imperial-parallax-y',`${d}px`)};const req=()=>{if(!tick){tick=true;requestAnimationFrame(paint)}};new IntersectionObserver(e=>{active=Boolean(e[0]?.isIntersecting);req()},{rootMargin:'20% 0px 20% 0px'}).observe(s);addEventListener('scroll',req,{passive:true})}function enhance(root){document.body.classList.add('imperial-watch-page');swatches(root);sync(root);normaliseMediaAlt(root);sticky(root);dialogs(root);parallax(root)}function boot(){document.querySelectorAll('[data-imperial-watch-pdp]').forEach(root=>{enhance(root);if(root.dataset.obs)return;root.dataset.obs='1';let q=false;new MutationObserver(()=>{if(q)return;q=true;requestAnimationFrame(()=>{q=false;enhance(root)})}).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','value']});root.addEventListener('change',()=>requestAnimationFrame(()=>enhance(root)))})}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();document.addEventListener('shopify:section:load',boot)})();


;

/* TRACKING */
(()=>{
  if(window.__imperialWatchGeneralTrackingBound)return;
  window.__imperialWatchGeneralTrackingBound=true;

  const clean=v=>String(v??'').replace(/\s+/g,' ').trim();
  const push=(event,payload={})=>{
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event,...payload});
  };
  const discoveryContext=()=>document.querySelector('[data-imperial-discovery-context]')?.dataset.imperialDiscoveryContext||'';
  const collectionContext=()=>{
    const context=discoveryContext();
    return ['collection-watches','collection-rolex'].includes(context)?context:'';
  };
  const watchRoot=el=>el?.closest?.('[data-imperial-watch-pdp]')||document.querySelector('[data-imperial-watch-pdp]');
  const pdpPayload=el=>{
    const root=watchRoot(el);
    if(!root)return{};
    return{
      item_name:clean(root.dataset.productTitle),
      product_url:clean(root.dataset.productUrl)||`${location.origin}${location.pathname}`,
      reference:clean(root.dataset.productReference),
      section_id:clean(root.dataset.sectionId)
    };
  };
  const actionEvents={
    whatsapp:'whatsapp_specialist_click',
    'source-model':'whatsapp_specialist_click',
    appointment:'book_viewing_click',
    'part-exchange':'part_exchange_click',
    'sell-part-exchange':'part_exchange_click',
    'additional-media':'request_media_click'
  };

  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null;
    if(!target)return;

    const offer=target.closest('[data-imperial-offer-open]');
    if(offer)push('make_offer_open',{...pdpPayload(offer),action_text:clean(offer.textContent)});

    const action=target.closest('[data-watch-action]');
    if(action){
      const eventName=actionEvents[action.dataset.watchAction];
      if(eventName)push(eventName,{...pdpPayload(action),action_text:clean(action.textContent),action_key:clean(action.dataset.watchAction)});
    }

    const productLink=target.closest('[data-imperial-list-item] a[href*="/products/"]');
    if(productLink&&!target.closest('[data-imperial-source-another]')){
      const item=productLink.closest('[data-imperial-list-item]');
      let productUrl='';
      try{const u=new URL(productLink.getAttribute('href'),location.origin);productUrl=`${u.origin}${u.pathname}`;}catch(e){}
      push('collection_product_click',{
        item_id:clean(item?.dataset.itemId),
        item_name:clean(item?.dataset.itemName)||clean(productLink.textContent),
        item_brand:clean(item?.dataset.itemBrand),
        item_category:clean(item?.dataset.itemCategory),
        item_list_name:clean(item?.dataset.itemListName),
        item_list_id:clean(item?.dataset.itemListId),
        index:item?.dataset.itemIndex===''||item?.dataset.itemIndex==null?undefined:Number(item.dataset.itemIndex),
        price:item?.dataset.itemPrice===''||item?.dataset.itemPrice==null?undefined:Number(item.dataset.itemPrice),
        currency:clean(item?.dataset.itemCurrency),
        product_url:productUrl
      });
    }

    const context=collectionContext();
    if(context){
      const clearAll=target.closest('a.active-facets__button-remove,.mobile-facets__clear');
      const removeFacet=clearAll?null:target.closest('a.active-facets__button');
      const facetAction=clearAll||removeFacet;
      if(facetAction){
        push('collection_filter',{
          collection_context:context.replace('collection-',''),
          filter_action:clearAll?'clear_all':'remove',
          filter_label:clean(facetAction.textContent),
          filter_name:'',
          filter_value:''
        });
      }
    }
  },true);

  document.addEventListener('submit',event=>{
    const form=event.target instanceof HTMLFormElement?event.target:null;
    if(form?.matches('.imperial-offer-form'))push('make_offer_submit',pdpPayload(form));
  },true);

  document.addEventListener('change',event=>{
    const context=collectionContext();
    if(!context)return;
    const el=event.target instanceof Element?event.target:null;
    if(!el?.matches('#FacetFiltersForm input,#FacetFiltersForm select,#FacetFiltersFormMobile input,#FacetFiltersFormMobile select,#FacetSortForm input,#FacetSortForm select,#FacetSortDrawerForm input,#FacetSortDrawerForm select'))return;
    const details=el.closest('details');
    const label=clean(details?.querySelector('summary span')?.textContent)||clean(el.getAttribute('aria-label'))||clean(el.name);
    const isSort=el.matches('#FacetSortForm input,#FacetSortForm select,#FacetSortDrawerForm input,#FacetSortDrawerForm select');
    if(isSort){
      push('collection_sort',{
        collection_context:context.replace('collection-',''),
        sort_name:clean(el.name),
        sort_label:label,
        sort_value:clean(el.value)
      });
      return;
    }
    push('collection_filter',{
      collection_context:context.replace('collection-',''),
      filter_action:'change',
      filter_name:clean(el.name),
      filter_label:label,
      filter_value:clean(el.value),
      checked:'checked' in el?Boolean(el.checked):undefined
    });
  },true);
})();


;

/* INBOX SUPPRESSION: CSS-only in imperial-page-motion-final.css */

/* RELATED CARD ENHANCER */
/* IMPERIAL WATCH PDP — CANONICAL ALL-WATCHES CARD ENHANCER — 02 OCT 2026 */
(function(){
  const KEY='imperial_time_watch_wishlist_v1';
  const ROOT='.related-products[data-imperial-watch-card-system="true"]';

  function clean(v){return String(v||'').replace(/\s+/g,' ').trim();}
  function esc(v){return String(v||'').replace(/[-/\\^$*+?.()|[\]{}]/g,'\\$&');}
  function titleCase(v){return clean(v).toLowerCase().replace(/\b\w/g,function(c){return c.toUpperCase();});}
  function rawTitle(card){
    if(card.dataset.itWatchRawTitle) return card.dataset.itWatchRawTitle;
    const h=card.querySelector('.card__heading a');
    const raw=h?clean(h.getAttribute('aria-label')||h.getAttribute('title')||h.textContent):'';
    if(raw) card.dataset.itWatchRawTitle=raw;
    return raw;
  }
  function vendorFor(card){
    return clean(card.querySelector('.it-watch-card-refrow__brand')?.textContent||card.querySelector('.product__vendor')?.textContent||'');
  }
  function productHref(card){
    const a=card.querySelector('.card__heading a,.card__media a');
    return a?String(a.getAttribute('href')||'#'):'#';
  }
  function isSoldOut(card){
    return !!card.querySelector('.wbsold_img') ||
      clean(card.querySelector('.it-watch-card-stock')?.textContent).toLowerCase()==='sold out';
  }
  function findRef(raw){
    const tokens=clean(raw).split(' ');
    return tokens.find(function(t){
      const x=t.replace(/[“”‘’'(),]/g,'');
      return (x.match(/\d/g)||[]).length>=4 && x.length>=5;
    })||'';
  }
  function rolexModel(raw){
    const low=raw.toLowerCase();
    return ['cosmograph daytona','gmt-master ii','oyster perpetual','submariner date','submariner','datejust ii','datejust','day-date','yacht-master','sky-dweller','sea-dweller','lady-datejust','air-king','explorer ii','explorer']
      .find(function(m){return low.includes(m);})||'';
  }
  function generalModel(v,raw){
    const low=raw.toLowerCase();
    const maps={
      'audemars piguet':['royal oak offshore','royal oak'],
      'patek philippe':['twenty~4','twenty-4','nautilus','aquanaut','calatrava'],
      'cartier':['santos de cartier','santos','tank française','tank francaise','tank','ballon bleu','panthère','panthere'],
      'omega':['speedmaster','seamaster','constellation','de ville']
    };
    if(v.toLowerCase()==='rolex') return rolexModel(raw);
    return (maps[v.toLowerCase()]||[]).find(function(m){return low.includes(m);})||'';
  }
  function pretty(m){
    const k=m.toLowerCase();
    if(k==='gmt-master ii') return 'GMT-Master II';
    if(k==='twenty~4') return 'Twenty~4';
    if(k==='twenty-4') return 'Twenty-4';
    return titleCase(m);
  }
  function royalPop(raw){
    if(!/royal pop/i.test(raw)) return null;
    const m=raw.match(/Royal Pop\s+(.+?)\s+(?:Bio[- ]?ceramic|Pocket Watch|Watch\b)/i);
    const variant=m?clean(m[1]).replace(/\bAudemars Piguet\b/ig,'').trim():'';
    const bits=[];
    if(/bio[- ]?ceramic/i.test(raw)) bits.push('Bio-ceramic Pocket Watch');
    if(/Audemars Piguet/i.test(raw)) bits.push('Audemars Piguet');
    return {title:'Royal Pop'+(variant?' '+titleCase(variant):''),spec:bits.join(' · ')};
  }
  function display(raw,v){
    const rp=royalPop(raw);
    if(rp) return rp;

    let t=clean(raw).replace(new RegExp('^'+esc(v)+'\\s+','i'),'');
    const model=generalModel(v,t);
    let out='';
    let explicitSize='';

    if(model){
      const idx=t.toLowerCase().indexOf(model);
      const after=t.slice(idx+model.length).trim();
      const ref=findRef(after);
      if(ref){
        const before=after.slice(0,after.indexOf(ref)).trim();
        const s=(before.match(/^\d{2}(?:\.\d)?(?:mm)?\b/i)||[])[0]||'';
        explicitSize=s.replace(/mm$/i,'');
      }
      out=pretty(model)+(explicitSize?' '+explicitSize:'');
    }else{
      const ref=findRef(t);
      out=ref?t.slice(0,t.indexOf(ref)).trim():t.split(/\b(?:19|20)\d{2}\b/)[0].trim();
    }

    if(v.toLowerCase()==='rolex' && /\b134300\b/.test(raw) && /oyster perpetual/i.test(raw)){
      out='Oyster Perpetual 41'; explicitSize='41';
    }

    let rest=t;
    if(model){
      const idx=rest.toLowerCase().indexOf(model);
      if(idx>=0) rest=rest.slice(idx+model.length).trim();
    }
    const ref=findRef(rest);
    if(ref) rest=rest.slice(rest.indexOf(ref)+ref.length).trim();
    rest=rest.replace(/\b(?:19|20)\d{2}\b/g,' ');
    rest=clean(rest
      .replace(/\bLuxury Mechanical Swiss Watch\b/ig,'')
      .replace(/\bLuxury Swiss Watch\b/ig,'')
      .replace(/\bMechanical Swiss Watch\b/ig,'')
      .replace(/\bSwiss Watch\b/ig,''));

    const bits=[];
    const dial=(rest.match(/(?:[A-Za-zÀ-ÿ'’\-]+\s+){0,4}[A-Za-zÀ-ÿ'’\-]+\s+Dial\b/i)||[])[0];
    if(dial) bits.push(clean(dial));
    const bracelet=(rest.match(/\b(?:Oyster[- ]?Flex|Oyster|Jubilee|President|Presidential|Leather|Rubber|Steel)\s+(?:Bracelet|Strap)\b/i)||[])[0];
    if(bracelet && !bits.some(function(x){return x.toLowerCase().includes(bracelet.toLowerCase());})) bits.push(clean(bracelet));
    if(!explicitSize){
      const mm=(rest.match(/\b\d{2}(?:\.\d)?mm\b/i)||[])[0];
      if(mm) explicitSize=mm.replace(/mm$/i,'');
    }
    if(explicitSize) bits.push(explicitSize+'mm');
    return {title:clean(out),spec:bits.slice(0,3).join(' · ')};
  }

  function yearFrom(raw){
    const m=raw.match(/\b(19|20)\d{2}\b/);
    return m?m[0]:'';
  }
  function materialFrom(raw){
    if(/bio[- ]?ceramic/i.test(raw)) return 'Bio-ceramic';
    if(/Everose Gold/i.test(raw)&&/Stainless Steel|Oystersteel/i.test(raw)) return 'Everose Gold & Steel';
    if(/Yellow Gold/i.test(raw)&&/Stainless Steel|Oystersteel/i.test(raw)) return 'Yellow Gold & Steel';
    if(/White Gold/i.test(raw)&&/Stainless Steel|Oystersteel/i.test(raw)) return 'White Gold & Steel';
    if(/Platinum/i.test(raw)) return 'Platinum';
    if(/Yellow Gold/i.test(raw)) return 'Yellow Gold';
    if(/White Gold/i.test(raw)) return 'White Gold';
    if(/Everose Gold|Rose Gold/i.test(raw)) return 'Rose Gold';
    if(/Stainless Steel|Oystersteel/i.test(raw)) return 'Stainless Steel';
    return '';
  }
  function statusFor(card,raw){
    if(isSoldOut(card)) return 'SOLD OUT';
    if(/unworn|pristine condition/i.test(raw)) return 'SALON READY';
    if(/showroom|kensington showroom/i.test(raw)) return 'IN SHOWROOM';
    return 'PHYSICAL STOCK';
  }
  function detailFor(card,raw){
    const year=yearFrom(raw);
    const material=materialFrom(raw);
    if(isSoldOut(card)) return {kind:'seal',text:'Pre-owned · Specialist sourcing'};
    if(/unworn/i.test(raw)){
      if(year&&material) return {kind:'seal',text:'Unworn · '+year+' · '+material};
      if(material) return {kind:'seal',text:'Unworn · '+material};
      if(year) return {kind:'seal',text:'Unworn · '+year};
      return {kind:'seal',text:'Unworn'};
    }
    if(/pristine condition/i.test(raw)){
      if(year&&material) return {kind:'seal',text:'Pristine condition · '+year+' · '+material};
      if(year) return {kind:'seal',text:'Pristine condition · '+year};
      return {kind:'seal',text:'Pristine condition'+(material?' · '+material:'')};
    }
    if(year && Number(year)<2000) return {kind:'seal',text:'Vintage reference · '+year+(material?' · '+material:'')};
    if(/diamond/i.test(raw)) return {kind:'seal',text:'Diamond specification'+(material?' · '+material:'')};
    if(year) return {kind:'truck',text:'Insured tracked delivery · '+year+' model'};
    if(material) return {kind:'truck',text:'Insured tracked delivery · '+material};
    return {kind:'truck',text:'Insured tracked delivery'};
  }
  function icon(kind){
    if(kind==='truck'){
      return '<span class="it-watch-card-trust-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 6.5h11v9H3z"/><path d="M14 9h3.8l3.2 3.3v3.2h-7"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="18" cy="17.5" r="1.7"/></svg></span>';
    }
    return '<span class="it-watch-card-trust-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m12 2 2.1 2.1 3-.3.9 2.9 2.7 1.4-1 2.8 1.6 2.5-2.3 1.9-.1 3-3 .5-1.7 2.5-2.7-1.2-2.7 1.2-1.7-2.5-3-.5-.1-3-2.3-1.9 1.6-2.5-1-2.8 2.7-1.4.9-2.9 3 .3z"/><path d="m8.5 12 2.2 2.2 4.8-4.8"/></svg></span>';
  }

  function saved(){try{const x=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(x)?x:[];}catch(_){return [];}}
  function store(x){try{localStorage.setItem(KEY,JSON.stringify(x));}catch(_){}}
  function updateHeart(btn,href){
    const active=saved().includes(href);
    btn.textContent=active?'♥':'♡';
    btn.setAttribute('aria-pressed',active?'true':'false');
    btn.setAttribute('aria-label',active?'Remove saved timepiece':'Save timepiece');
    btn.setAttribute('title',active?'Remove saved timepiece':'Save timepiece');
  }
  function ensureHeart(card){
    const inner=card.querySelector('.card__inner');
    const href=productHref(card);
    if(!inner||!href||href==='#') return;
    let btn=inner.querySelector('.it-watch-heart');
    if(!btn){
      btn=document.createElement('button');
      btn.type='button';
      btn.className='it-watch-heart';
      inner.appendChild(btn);
      btn.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        let list=saved();
        list=list.includes(href)?list.filter(function(x){return x!==href;}):list.concat(href);
        store(list);
        updateHeart(btn,href);
      });
    }
    updateHeart(btn,href);
  }

  function ensureSpec(card,raw,vendor){
    const info=card.querySelector('.card__information');
    const h=card.querySelector('.card__heading a');
    if(!info||!h) return;
    const x=display(raw,vendor);
    if(x.title){
      h.textContent=x.title;
      h.setAttribute('aria-label',raw);
      h.setAttribute('title',raw);
    }
    let spec=info.querySelector('.it-watch-card-spec');
    if(!spec){
      spec=document.createElement('div');
      spec.className='it-watch-card-spec';
      h.closest('.card__heading')?.insertAdjacentElement('afterend',spec);
    }
    if(spec) spec.textContent=x.spec||'';
  }
  function ensureStatus(card,raw){
    const status=card.querySelector('.it-watch-card-stock');
    if(status) status.textContent=statusFor(card,raw);
  }
  function ensureTrust(card,raw){
    const info=card.querySelector('.card__information');
    if(!info) return;
    let row=card.querySelector('.it-watch-card-facts')||card.querySelector('.it-watch-card-service');
    if(!row){
      row=document.createElement('div');
      row.className='it-watch-card-service';
      const price=card.querySelector('.card-information.card_price_bottom');
      if(price) price.insertAdjacentElement('afterend',row);
      else info.appendChild(row);
    }
    const d=detailFor(card,raw);
    row.innerHTML=icon(d.kind)+'<span class="it-watch-card-trust-text">'+d.text+'</span>';
  }
  function hideDuplicateSource(card){
    card.querySelectorAll('a,button').forEach(function(el){
      if(el.classList.contains('it-watch-card-cta')) return;
      if(/source another/i.test(clean(el.textContent))) el.classList.add('it-watch-native-source-hidden');
    });
  }
  function ensureCTA(card){
    const sold=isSoldOut(card);
    let cta=card.querySelector('.it-watch-card-cta');
    if(!cta){
      cta=document.createElement('a');
      cta.className='it-watch-card-cta';
      card.querySelector('.card__content')?.appendChild(cta);
    }
    if(!cta) return;
    cta.href=productHref(card);
    cta.classList.toggle('it-watch-card-cta--sold',sold);
    cta.textContent=sold?'SOURCE ANOTHER':'INSPECT TIMEPIECE';
  }
  function polish(card){
    const raw=rawTitle(card);
    const vendor=vendorFor(card);
    if(!raw) return;
    ensureSpec(card,raw,vendor);
    ensureStatus(card,raw);
    ensureTrust(card,raw);
    ensureCTA(card);
    ensureHeart(card);
    hideDuplicateSource(card);
  }
  function run(){
    document.querySelectorAll(ROOT+' .card').forEach(polish);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();

  let timer;
  const observer=new MutationObserver(function(records){
    if(records.some(function(r){
      const t=r.target;
      return t && t.closest && (t.closest(ROOT) || t.matches?.(ROOT));
    })){
      clearTimeout(timer);
      timer=setTimeout(run,16);
    }
  });
  observer.observe(document.documentElement,{subtree:true,childList:true});
  document.addEventListener('shopify:section:load',function(){requestAnimationFrame(run);});
})();